import { Box, Container, Grid, Paper, Typography, Avatar } from '@mui/material';
import { Quote } from 'lucide-react';

export function Testimonials({ data }) {
  const primaryColor = data.primary_color || '#1e3a8a';
  const testimonials = Array.isArray(data.testimonials) ? data.testimonials : [];

  if (testimonials.length === 0) return null;

  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: '#f8fafc' }}>
      <Container maxWidth="lg">
        <Box sx={{ textAlign: 'center', maxWidth: 640, mx: 'auto', mb: 7 }}>
          <Box sx={{ display: 'inline-block', px: 2, py: 0.5, borderRadius: 4, backgroundColor: `${primaryColor}15`, color: primaryColor, mb: 1.5 }}>
            <Typography variant="caption" fontWeight={700} letterSpacing="0.05em">
              VOICES OF OUR COMMUNITY
            </Typography>
          </Box>
          <Typography variant="h2" fontWeight={800} color="#0f172a" sx={{ fontSize: { xs: '2rem', md: '2.5rem' }, mb: 1 }}>
            What Parents & Alumni Say
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Hear directly from our school community about their experiences and achievements.
          </Typography>
        </Box>

        <Grid container spacing={4}>
          {testimonials.map((item, index) => (
            <Grid size={{ xs: 12, md: 4 }} key={item.id || index}>
              <Paper
                elevation={0}
                sx={{
                  p: 4,
                  height: '100%',
                  borderRadius: 4,
                  backgroundColor: '#ffffff',
                  border: '1px solid #e2e8f0',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'space-between',
                  position: 'relative',
                  boxShadow: '0 10px 25px rgba(0,0,0,0.04)',
                }}
              >
                <Box>
                  <Quote size={32} color={primaryColor} style={{ opacity: 0.3, marginBottom: 16 }} />
                  <Typography variant="body1" color="#334155" sx={{ fontStyle: 'italic', lineHeight: 1.7, mb: 3 }}>
                    "{item.quote}"
                  </Typography>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, pt: 2, borderTop: '1px solid #f1f5f9' }}>
                  {item.avatar && (
                    <Avatar src={item.avatar} alt={item.author} sx={{ width: 44, height: 44, border: `2px solid ${primaryColor}` }} />
                  )}
                  <Box>
                    <Typography variant="subtitle2" fontWeight={800} color="#0f172a">
                      {item.author}
                    </Typography>
                    {item.relation && (
                      <Typography variant="caption" color="text.secondary" fontWeight={600}>
                        {item.relation}
                      </Typography>
                    )}
                  </Box>
                </Box>
              </Paper>
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  );
}

export default Testimonials;
